import React from "react";
import "./GoogleReviewCard.css";

const GoogleReviewCard = () => {
  return (
    <div className="review-card-container">
      <a
        href="https://www.google.com/search?client=ms-android-samsung-ss&sca_esv=5cc206c00662e0d1&cs=1&sxsrf=AHTn8zqfbnuPVC9v4mTbKkol3TJ5niciaQ:1743836802207&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzcktPBxn_9TY-XMp_5DPpve40mAKlB7_PiwDCfnd12ymqj-kiRAYCxZLn8rHEfYhar4ObVooB-q3kz-PnbS4HjcLew89rYaIJuaNHvc7Zi9B9cZXWw%3D%3D&q=R.D%27S+Creation%27s+Reviews&sa=X&ved=2ahUKEwiXgJGpqsCMAxXNaPUHHQzlN6kQ0bkNegQIIhAD&cshid=1743836829479817&biw=1920&bih=953&dpr=1#lrd=0x3be7b1036f8418b7:0x30dd589e76a7d9e3,3,,,,"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/Images/WhatsApp Image 2025-04-05 at 10.32.06 (1) copy.jpeg"
          alt="Review us on Google"
          className="review-card-image"
        />
      </a>
      <p className="review-card-note">
        Click the image to review us on Google!
      </p>
    </div>
  );
};

export default GoogleReviewCard;